import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const COMMON_INFO_URL = `/api/common-info`;

export const commonInfoApi = createApi({
  reducerPath: 'commonInfo.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['commonInfo'],
  endpoints: (builder) => ({
    getCommonInfos: builder.query({
      query: ({
        pageNo = 0,
        pageSize = DEFAULT_ROWS_PER_PAGE,
        name = '',
        type = '',
        used = '',
        channelAvailable = '',
      }) => {
        let queryString = `${COMMON_INFO_URL}?pageNo=${pageNo}&pageSize=${pageSize}&used=${used}&channelAvailable=${channelAvailable}`;
        if (name != '') {
          queryString += `&name=${name}`;
        }
        if (type != 'all') {
          queryString += `&type=${type}`;
        }
        return { url: queryString };
      },
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['commonInfo'],
    }),
    getCommonInfoById: builder.query({
      query: (id) => ({ url: `${COMMON_INFO_URL}/${id}` }),
      providesTags: ['commonInfo'],
    }),
    addCommonInfo: builder.mutation({
      query: (body) => ({
        url: `${COMMON_INFO_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['commonInfo'],
    }),
    deleteCommonInfo: builder.mutation({
      query: (id) => ({
        url: `${COMMON_INFO_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['commonInfo'],
    }),
    updateCommonInfo: builder.mutation({
      query: (data) => ({
        url: `${COMMON_INFO_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['commonInfo'],
    }),
  }),
});

export const {
  useGetCommonInfosQuery,
  useGetCommonInfoByIdQuery,
  useAddCommonInfoMutation,
  useDeleteCommonInfoMutation,
  useUpdateCommonInfoMutation,
} = commonInfoApi;
